export const STEAM_PRIVACY_SETTINGS_URL =
  "https://steamcommunity.com/my/edit/settings";

export const APPLICATION_FEEDBACK_CANNED_RESPONSES = [
  {
    id: "private_steam_profile",
    label: "Private Steam profile",
    flaggedFields: ["steamProfileUrl"],
    body: [
      "Your Steam profile is currently private, so we cannot review the account you signed up with.",
      "",
      "Please set your Steam profile to Public in your privacy settings:",
      STEAM_PRIVACY_SETTINGS_URL,
      "",
      "After saving, open your Steam profile in an incognito/private browser window to confirm it is publicly visible, then re-submit your application.",
    ].join("\n"),
  },
  {
    id: "hidden_cs2_hours",
    label: "No visible CS2 hours",
    flaggedFields: ["steamProfileUrl"],
    body: [
      "We cannot see CS2 hours on the Steam account you signed up with.",
      "",
      "Please update your Steam privacy settings:",
      "1. Set your Steam profile to Public",
      "2. Set Game details to Public",
      '3. Uncheck "Always keep my total playtime private"',
      "",
      STEAM_PRIVACY_SETTINGS_URL,
      "",
      "Then open your Steam profile in an incognito/private browser window and confirm CS2 is in your games list with hours visible. After that, re-submit your application.",
    ].join("\n"),
  },
  {
    id: "private_friends_list",
    label: "Private friends list",
    flaggedFields: ["steamProfileUrl"],
    body: [
      "Your Steam friends list appears to be private. Please set Friends List to Public in your Steam privacy settings, then re-submit your application:",
      STEAM_PRIVACY_SETTINGS_URL,
    ].join("\n"),
  },
  {
    id: "unreadable_id_document",
    label: "Unreadable ID document",
    flaggedFields: ["passport"],
    body: "The identity document you uploaded is not clear enough to verify. Please upload a well-lit, fully readable photo of the document (name, date of birth, and photo visible), then re-submit your application.",
  },
  {
    id: "selfie_video_retake",
    label: "Selfie video needs a retake",
    flaggedFields: ["selfie_video"],
    body: "We could not clearly verify your selfie video. Please record a new video that clearly shows your face, and hold up your Steam profile so the page is readable on camera, then re-submit your application.",
  },
];

export const NOT_ELIGIBLE_CANNED_RESPONSES = [
  {
    id: "no_competitive_record",
    label: "No competitive record",
    body: [
      "The Steam account you signed up with does not have an established competitive CS2 track record. We could not find a history of competitive matches on this account, so it does not currently meet Ouro's eligibility requirements.",
      "",
      "Ouro is built for players with an established competitive history on the Steam account they apply with.",
    ].join("\n"),
  },
  {
    id: "new_or_unused_account",
    label: "New / unused Steam account",
    body: [
      "The Steam account you signed up with appears to be new or unused, rather than an established competitive profile. Ouro does not accept alt or throwaway Steam accounts.",
      "",
      "If you have a primary Steam account with an established competitive history, you can appeal from your Account Settings page.",
    ].join("\n"),
  },
];

export function containsCannedResponse(currentText, templateBody) {
  const text = String(currentText || "");
  const body = String(templateBody || "").trim();
  if (!body) return false;
  return text.includes(body);
}

export function toggleCannedResponse(currentText, templateBody) {
  const text = String(currentText || "");
  const body = String(templateBody || "").trim();
  if (!body) return text.trim();

  if (containsCannedResponse(text, body)) {
    return text
      .replace(body, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  const trimmed = text.trim();
  return trimmed ? `${trimmed}\n\n${body}` : body;
}
